import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import { userPath } from '../config/paths';
import { useTranslation } from '../i18n';

/**
 * 面包屑（纯展示）。crumbs 由调用方从路由元数据表派生：
 * user 端见 user/navigation.jsx 的 resolveRoute()。
 * crumbs: [{ label, path? }]，有 path 的可点击。
 */
const AppBreadcrumb = ({ crumbs = [], homePath = '/dashboard' }) => {
  const { t } = useTranslation();
  const items = [
    { title: <Link to={userPath(homePath)} aria-label={t('Overview')}><HomeOutlined /></Link> },
    ...crumbs.map((c) => ({
      title: c.path ? <Link to={userPath(c.path)}>{t(c.label)}</Link> : t(c.label),
    })),
  ];
  return <Breadcrumb items={items} style={{ fontSize: 13, marginBottom: 12 }} className="app-breadcrumb" />;
};

export default AppBreadcrumb;
